var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/organization/OrganizationModel',['require','underscore','evertrue','models/roles/RoleModel','models/FeaturesModel','ET/ETModel'],function(require) {
  var ETModel, EverTrue, FeaturesModel, OrganizationModel, RoleModel, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  RoleModel = require("models/roles/RoleModel");
  FeaturesModel = require("models/FeaturesModel");
  ETModel = require("ET/ETModel");
  return OrganizationModel = (function(_super) {
    __extends(OrganizationModel, _super);

    function OrganizationModel() {
      return OrganizationModel.__super__.constructor.apply(this, arguments);
    }

    OrganizationModel.prototype.urlRoot = "auth/organizations";

    OrganizationModel.prototype.storageName = "organization";

    OrganizationModel.prototype.create = function(data, callback) {
      var options;
      options = {
        type: "POST",
        url: EverTrue.conf.apiBase + "auth/organizations?app_key=" + EverTrue.conf.app_keys.console,
        data: {
          organization: {
            name: data.org_name,
            slug: data.org_slug,
            max_contact_count: data.number_of_records
          }
        },
        headers: {
          "Authorization-Provider": "EvertrueAuthToken",
          "Authorization": EverTrue.Session.get("id")
        },
        success: function(response) {
          if (_.isFunction(callback)) {
            return callback(response);
          }
        },
        error: function() {
          return EverTrue.alertView.alert("error", {
            message: "This org failed to create."
          });
        }
      };
      return $.ajax(options);
    };

    OrganizationModel.prototype.enableSchemaAndRoles = function(org, products) {
      var authParams, requests, roles, _ref, _ref1;
      if (products == null) {
        products = {};
      }
      authParams = "app_key=" + EverTrue.conf.app_keys.console + "&auth_provider=evertrueauthtoken&auth=" + EverTrue.Session.get("id");
      roles = [
        {
          name: "Admin",
          can_see_private_data: true,
          remote_id: "Admin"
        }, {
          name: "Alumni",
          "default": true,
          can_see_private_data: false,
          remote_id: "Alumni"
        }, {
          name: "Console User",
          can_see_private_data: false,
          remote_id: "Console User"
        }
      ];
      if ((_ref = products.givingtree) != null ? _ref.name : void 0) {
        roles.push({
          name: "GivingTree User",
          can_see_private_data: true,
          remote_id: "GivingTree User"
        });
        roles.push({
          name: "GivingTree Owner",
          can_see_private_data: true,
          remote_id: "GivingTree Owner"
        });
      }
      if ((_ref1 = products.volunteers) != null ? _ref1.name : void 0) {
        roles.push({
          name: "Volunteer",
          can_see_private_data: false,
          remote_id: "Volunteer"
        });
        roles.push({
          name: "Volunteer Lead",
          can_see_private_data: false,
          remote_id: "Volunteer Lead"
        });
      }
      requests = _.map(roles, function(role) {
        var model;
        model = new RoleModel(role);
        model.setOrganization(org.id);
        return model.save();
      });
      return $.when.apply(void 0, requests).done(function() {
        return $.ajax({
          type: "POST",
          url: EverTrue.conf.apiBase + "contacts/v1/properties/schema?oid=" + org.id + "&" + authParams
        });
      });
    };

    OrganizationModel.prototype.parse = function(data) {
      data.id = parseInt(data.id, 10);
      return data;
    };

    OrganizationModel.prototype.fetch = function(callback) {
      return EverTrue.api({
        url: this.urlRoot + "/" + this.get("id"),
        success: (function(_this) {
          return function(response) {
            _this.set(response);
            if (_.isFunction(callback)) {
              return callback(response);
            }
          };
        })(this)
      });
    };

    OrganizationModel.prototype.hasProduct = function(name) {
      var products, _ref;
      products = (_ref = EverTrue.DNA) != null ? _ref.get("ET.Org.Products") : void 0;
      return !!_.findWhere(products, {
        name: name
      });
    };

    OrganizationModel.prototype.hasFeature = function(feature) {
      var features;
      features = new FeaturesModel;
      features.init();
      return _.contains(features.get("features"), feature);
    };

    return OrganizationModel;

  })(ETModel);
});

//# sourceMappingURL=OrganizationModel.js.map
;
